import { QueryClient } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';

export const defaultQueryClientOptions = {
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 500,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      suspense: false,
      useErrorBoundary: false,
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
      cacheTime: 1000 * 60 * 60 * 24 * 7, // 1 week
    },
  },
} as const;

const queryClient = new QueryClient(defaultQueryClientOptions);

const persister = createSyncStoragePersister({
  storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  key: 'REACTIIVE_CACHE',
  throttleTime: 1000,
});

export const QueryProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 1000 * 60 * 60 * 24 * 7, // 1 week
        buster: '1.0',
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
};
